import { Directive, effect, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { HelperOverrides, applyHelperCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-helper',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxHelperStyleDirective {
  componentStyle = input<{
    style: HelperOverrides
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyHelperCustomStyles(this.componentStyle().style, theme(), fonts())
      this.styleClassName.set(className)
    })
  }
}
